"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Dropdown = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.json.stringify.js");
var _react = _interopRequireWildcard(require("react"));
var _reactHookForm = require("react-hook-form");
var _hooks = require("../../../../hooks");
var _ValidationMessages = require("../ValidationMessages");
var _Spinner = require("../../../UIElements/Spinner/Spinner");
var _FieldLabelText = require("../FieldLabelText");
var _objectHelpers = require("../../../../helpers/objectHelpers");
var _formFieldPropTypes = require("../../../../propTypes/formFieldPropTypes");
const _excluded = ["fieldFormContext", "name", "id", "label", "labelId", "labelTooltip", "includeEmptyOption", "hideLabel", "labelIsInset", "defaultValue", "showSpinner", "validation", "options", "customCssClass", "labelCustomCssClass", "inputCustomCssClass", "customChangeHandler", "onBlur", "customTrackingData", "customTrackingEvents", "crossFieldValidator", "deps"],
  _excluded2 = ["ref"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const Dropdown = _ref => {
  let {
      fieldFormContext,
      name,
      id,
      label,
      labelId,
      labelTooltip,
      includeEmptyOption = true,
      hideLabel = false,
      labelIsInset = false,
      defaultValue,
      showSpinner,
      validation,
      options,
      customCssClass,
      labelCustomCssClass,
      inputCustomCssClass,
      customChangeHandler = () => {},
      onBlur = () => {},
      customTrackingData,
      customTrackingEvents,
      crossFieldValidator,
      deps = []
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const hookFormContext = (0, _reactHookForm.useFormContext)();
  const formContext = fieldFormContext || hookFormContext;
  const {
    register
  } = formContext || {
    register: () => {}
  };
  const fieldElement = (0, _react.useRef)(null);
  const [isTouched, setIsTouched] = (0, _react.useState)(false);
  const fieldState = formContext && formContext.getFieldState(name);
  const initialValue = (0, _objectHelpers.IsAnObject)(defaultValue) ? defaultValue.value : defaultValue;
  const labelProps = {
    label,
    labelId,
    inputId: id || name,
    labelTooltip,
    hideLabel,
    validation
  };
  const HandleAutoFill = event => {
    const {
      value,
      selectedIndex,
      selectedOptions
    } = event.target;
    formContext.setValue(name, value);
    customChangeHandler(event, value, selectedIndex, selectedOptions);
  };
  const HandleOnBlur = () => {
    setIsTouched(true);
    onBlur();
  };
  (0, _hooks.useTracking)({
    elementRef: fieldElement,
    trackingProps: {
      label,
      field: {
        fieldState: fieldState || {},
        inputType: 'select',
        defaultValue: initialValue,
        isFetchingData: showSpinner,
        name,
        id: id || name
      }
    },
    customTrackingData,
    customTrackingEvents
  });
  if (typeof crossFieldValidator !== 'undefined') {
    const {
      fieldsToWatch,
      validators
    } = crossFieldValidator;
    const watchValues = fieldsToWatch.reduce((acc, fieldToWatch) => {
      acc[fieldToWatch] = formContext.watch(fieldToWatch);
      return acc;
    }, {});
    validation.validate = value => {
      let hasError = false;
      let errorMessage = '';
      fieldsToWatch.forEach(fieldToWatch => {
        const isValid = validators[fieldToWatch](value, watchValues);
        if (!hasError && typeof isValid === 'string') {
          hasError = true;
          errorMessage = isValid;
        }
      });
      return hasError ? errorMessage : true;
    };
  }
  const _register = register(name, _objectSpread(_objectSpread({}, validation), {}, {
      deps,
      onChange: HandleAutoFill,
      onBlur: HandleOnBlur
    })),
    {
      ref: hookFormRef
    } = _register,
    hookFormRegistration = _objectWithoutProperties(_register, _excluded2);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "formField dropdownField ".concat(customCssClass || '', " ").concat(isTouched ? 'touched' : '')
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "".concat(labelCustomCssClass || '', " ").concat(showSpinner ? 'withSpinner' : '', " ").concat(hideLabel ? 'hiddenLabel' : ''),
    htmlFor: id || name
  }, !labelIsInset && /*#__PURE__*/_react.default.createElement(_FieldLabelText.FieldLabelText, labelProps), /*#__PURE__*/_react.default.createElement("select", _extends({}, rest, {
    defaultValue: initialValue,
    id: id || name,
    name: name,
    className: "".concat(inputCustomCssClass || '').concat(fieldState !== null && fieldState !== void 0 && fieldState.invalid ? ' invalidField' : ''),
    required: validation && validation.required
  }, hookFormRegistration, {
    ref: e => {
      hookFormRef(e);
      fieldElement.current = e;
    }
  }), includeEmptyOption && /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }, "Please select"), options && options.map(option => {
    if ((0, _objectHelpers.IsAnObject)(option) && typeof option.value !== 'undefined' && typeof option.label !== 'undefined') {
      return /*#__PURE__*/_react.default.createElement("option", {
        key: "".concat(id, "_").concat(option.value),
        "data-option": JSON.stringify(option),
        value: option.value
      }, option.label);
    }
    return /*#__PURE__*/_react.default.createElement("option", {
      key: "".concat(id, "_").concat(option),
      "data-option": JSON.stringify(option),
      value: option
    }, option);
  })), labelIsInset && /*#__PURE__*/_react.default.createElement(_FieldLabelText.FieldLabelText, labelProps), showSpinner && /*#__PURE__*/_react.default.createElement(_Spinner.Spinner, null)), /*#__PURE__*/_react.default.createElement(_ValidationMessages.ValidationMessages, {
    formContext: formContext,
    name: name,
    validation: validation
  }));
};
exports.Dropdown = Dropdown;
Dropdown.propTypes = _formFieldPropTypes.DropdownPropTypes;
Dropdown.defaultTypes = _formFieldPropTypes.FormFieldDefaultProps;
var _default = exports.default = Dropdown;